export default "__VITE_ASSET__da8e9be4__"